import React, { useState, useEffect } from "react";
import "./Login.css";
import GradientButton from "../../components/button/Button";
import { Logo } from "../../images/Images";
import axiosInstance from "../../axiosInstance";
import { toast } from "react-toastify";
import LoadingComponent from "../../components/loading/Loading";

const CreatePassword: React.FC = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [token, setToken] = useState("");
  const [forgotId, setForgotId] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Retrieve forgot_id from localStorage
    const storedForgotId = localStorage.getItem("forgot_id");
    setForgotId(storedForgotId);
  }, []);

  const validatePassword = (password: string) => {
    // Password strength validation
    const minLength = 8;
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumbers = /[0-9]/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

    if (password.length < minLength) {
      toast.error("Password must be at least 8 characters long");
      return false;
    }

    if (!hasUpperCase || !hasLowerCase || !hasNumbers || !hasSpecialChar) {
      toast.error(
        "Password must contain uppercase, lowercase, number, and special character"
      );
      return false;
    }

    return true;
  };

  const validateToken = (token: string) => {
    // Token validation (example: ensure it's not empty or malformed)
    if (!token) {
      toast.error("Token is required");
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (!forgotId) {
      toast.error("Forgot ID not found. Please restart the process.");
      return;
    }

    if (!validateToken(token)) return;

    if (!validatePassword(password)) return;

    if (password !== confirmPassword) {
      toast.error("Passwords do not match!");
      return;
    }

    const payload = {
      token: token,
      id: forgotId,
      password: password,
      confirm_password: password,
    };

    console.log("Payload:", payload);

    setLoading(true);
    try {
      const res = await axiosInstance.put("/auth/reset-password", payload);
      if (res.data) {
        toast.success(res.data.message);
        setTimeout(() => {
          window.location.href = "/login";
        }, 3000);
      }
    } catch (error: any) {
      console.log(error);

      if (error.response.data.errors > 0) {
        Object.values(error.response.data.errors).forEach((errMsg: any) => {
          toast.error(errMsg);
        });
      } else {
        toast.error(error.response?.data?.message || "Error verifying token");
      }
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <LoadingComponent />;
  }

  return (
    <div className="login-page">
      {/* Left-side Image */}
      <div className="login-page__image create_password">
        <img
          src="https://img.freepik.com/free-photo/top-view-vegetables-fruits-zucchini-bell-peppers-apples-quince-cherry-tomatoes-cumcuat-parsley-cabbage-lemon-pomegranates_140725-59438.jpg?uid=R27806234&ga=GA1.1.1852762410.1725342281&semt=ais_hybrid"
          alt="Fresh Produce"
        />
      </div>

      {/* Right-side Form */}
      <div className="login-page__form-container">
        <form
          className="login-page__form"
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
        >
          <div className="login-page__title">
            <img src={Logo} alt="logo" />
          </div>
          <h2 className="login-page__subtitle">Create Password</h2>
          <p className="login-page__description">Enter your New Password </p>

          {/* Input Fields */}
          <div className="login-page__input-group">
            <label>Password</label>
            <input
              type="password"
              required
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <div className="login-page__input-group">
            <label>Confirm Password</label>
            <input
              type="password"
              required
              placeholder="Re-enter your password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </div>

          <div className="login-page__input-group">
            <label>Enter Token</label>
            <input
              type="text"
              required
              placeholder="Enter token"
              value={token}
              onChange={(e) => setToken(e.target.value)}
            />
          </div>

          <div className="gd-btn">
            <GradientButton text="Create Password" onClick={handleSubmit} />
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreatePassword;
